import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import LocationOnIcon from '@material-ui/icons/LocationOn';
class AddressInput extends React.Component {
  static propTypes = {
    error: PropTypes.string,
    placeholder: PropTypes.string,
    includeAdornment: PropTypes.bool,
    isOnDarkBackground: PropTypes.bool
  };

  static defaultProps = {
    error: '',
    placeholder: '',
    includeAdornment: false,
    isOnDarkBackground: false
  };

  render() {
    const {
      error,
      includeAdornment,
      isOnDarkBackground,
      ...textFieldProps
    } = this.props;

    // if on dark background, we don't want a border.
    // the border creates a gap between the mui error border
    // https://share.getbento.com/7KuR1BBg
    const filledInputStyles = isOnDarkBackground ? { border: 0 } : {};
    return (
      <TextField
        {...textFieldProps}
        variant="filled"
        fullWidth
        inputProps={{
          'data-testid': 'address-input'
        }}
        placeholder={this.props.placeholder}
        error={!!this.props.error}
        InputProps={{
          disableUnderline: !this.props.error,
          style: filledInputStyles,
          endAdornment: includeAdornment && (
            <InputAdornment position="end">
              <LocationOnIcon />
            </InputAdornment>
          )
        }}
      />
    );
  }
}

export default AddressInput;
